import { render, staticRenderFns } from "./Customize.vue?vue&type=template&id=72d75061"
import script from "./Customize.vue?vue&type=script&lang=js"
export * from "./Customize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports